import { FunctionComponent } from 'react';
import styles from '../../../styles.module.scss';

export const OccurrenceBlockDescription: FunctionComponent<{
    occurrenceBlockDescription?: string | null;
}> = ({ occurrenceBlockDescription }) => {
    if (!occurrenceBlockDescription) {
        return null;
    }

    return <p className={styles.blockDescription}>{occurrenceBlockDescription}</p>;
};
